import React, { Fragment } from "react";
import { Table, Popover, Overlay, Modal, Row, Col } from "react-bootstrap";
import StudentController from "../api/StudentController";
import { withData } from "../common/WithData";
import SubjectsTableView from "./SubjectsTableView";

interface SubjectsViewProps
{
    data: Class;
    termCode: string;
}

class SubjectsView extends React.Component<SubjectsViewProps>
{
    studentController: StudentController;

    constructor(props: SubjectsViewProps) 
    {
        super(props);

        this.studentController = new StudentController();
    }

    changeAssignmentTotal()
    {

    }

    render(): React.ReactNode 
    {

        return <Fragment>
            <Table responsive="lg" className="list">
                <thead>
                    <tr style={{ color: "grey" }}>
                        <th>SUBJECT</th>
                        <th>SUBJECT TITLE</th>
                        {/*<th>ASSIGNMENTS</th>*/}
                        <th>STATUS</th>
                        <th>INSTRUCTOR</th>
                        <th>UNITS</th>
                        <th>GRADE</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        (this.props.data.subjects && this.props.data.subjects.length > 0)
                            ?
                            this.props.data.subjects.map((subject: ClassSubject, i: number) => 
                            {
                                return <SubjectsTableView termCode={this.props.termCode} class={subject} key={i} />;
                            })
                            :
                            <div></div>
                    }
                </tbody>
            </Table>
        </Fragment>;
    }
}

export default SubjectsView;